export const CONTACT_TYPE = {
  general: "general",
  jobs: "jobs",
  partners: "partners",
  campaign: "campaign",
};

export const FORM_TYPE = {
  generalNL: "form_contact_nl",
  generalFR: "form_contact_fr",
  generalEN: "form_contact_en",
  jobsNL: "form_jobs_nl",
  jobsFR: "form_jobs_fr",
  jobsEN: "form_jobs_en",
  partnerNL: "form_kantoren_nl",
  partnerFR: "form_kantoren_fr",
  partnerEN: "form_kantoren_en",
  campaignNL: "form_campaign_nl",
  campaignFR: "form_campaign_fr",
  campaignEN: "form_campaign_en",
};

export const CONTACT_GTM_EVENT = "form_submission";
export const CAMPAIGN_GTM_EVENT = "campaign_form_submission";
